module.exports = __webpack_public_path__ + "experience/innovation/models/simulation-scene.62e7abb.obj";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/models/simulation-scene.obj
// module id = W+lJ
// module chunks = 1